import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * ラジオボタン
 *【ラジオボタンリスト:options:{label:string, value:string}[]】
 *【非活性:disabled:boolean】
 *【選択項目:checked:string】
 *【ラベル内容:labelContent:string】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-radio-button-field',
  templateUrl: './radio-button-field.html',
  styles: [`
    
  `]
})
export class RadioButtonField extends BaseWidget {
  /**
   * 選択項目の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択項目に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラジオボタンリスト
   */
  @Input() options:{label:string, value:string}[]

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * 選択項目
   */
  @Input() checked:string

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  updateChecked(event:Event, index:number):string {
    if (!!this.disabled) return
    const value = this.options[index].value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event, index)
    return value
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/radio_button/radio-button-field/radio-button-field.component.ts